import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { faTimes, faPlus, faMinus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AutoComplete } from 'primereact/autocomplete';
import { OrderList } from 'primereact/orderlist';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';

import classNames from 'classnames';

import { useFormCreateOrderService } from 'src/controllers/OrderService/CreateOrderServiceController';
import { useData } from 'src/contexts/data';
import LoadingScreen from 'src/components/LoadingScreen';
import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog';
import { InputMask } from 'primereact/inputmask';

interface filteredFieldProps {
  DESCRICAO_PRODUTO?: string;
  DESCRICAO_SERVICO?: string;
  FT_SERVICO?: string;
  AX_PRODUTO?: string;
  VALOR_PRODUTO?: number | string;
  VALOR_SERVICO?: number | string;
  QUANTIDADE_PRODUTO?: number;
  QUANTIDADE_SERVICO?: number;
};

interface filteredProps {
  label: string;
  value?: string;
};

const EditOrderServiceForm: React.FC = () => {
  let history = useHistory();
  const { selectedOrderService } = useData();

  const [serviceResponse, setServiceResponse] = useState<any[]>([]);
  const [serviceOrderTypeResponse, setServiceOrderTypeResponse] = useState<any[]>([]);
  const [valueServiceOrderType, setValueServiceOrderType] = useState('');
  const [filteredServiceOrderTypes, setFilteredServiceOrderType] = useState<filteredProps[]>([{ label: '', value: '' }]);
  const [valueProduct, setValueProduct] = useState<filteredFieldProps>({ DESCRICAO_PRODUTO: '', AX_PRODUTO: '', VALOR_PRODUTO: '', QUANTIDADE_PRODUTO: 0 });
  const [valueService, setValueService] = useState<filteredFieldProps>({ DESCRICAO_SERVICO: '', FT_SERVICO: '', VALOR_SERVICO: '', QUANTIDADE_SERVICO: 0 });
  const [filteredProduct, setFilteredProduct] = useState<filteredFieldProps[]>([{ DESCRICAO_PRODUTO: '', AX_PRODUTO: '', VALOR_PRODUTO: '', QUANTIDADE_PRODUTO: 0 }]);
  const [filteredService, setFilteredService] = useState<filteredFieldProps[]>([{ DESCRICAO_SERVICO: '', FT_SERVICO: '', VALOR_SERVICO: '', QUANTIDADE_SERVICO: 0 }]);

  const {
    getOrderServiceFormController,
    handleOrderServiceFormController
  } = useFormCreateOrderService();

  useEffect(() => {
    setFilteredProduct(getOrderServiceFormController.ProductData)
    setFilteredService(getOrderServiceFormController.ServiceData)
  }, []);

  useEffect(() => {
    if (selectedOrderService.DEMANDA) {
      handleOrderServiceFormController.setProductList(selectedOrderService.PRODUTOS);
      handleOrderServiceFormController.setServiceList(selectedOrderService.SERVICOS);
      setValueServiceOrderType(selectedOrderService.DESCRICAO_TIPOORDEMSERVICO || '');
      getOrderServiceFormController.formikEdit.setFieldValue('TIPOORDEMSERVICO', selectedOrderService.TIPOORDEMSERVICO);
      getOrderServiceFormController.formikEdit.setFieldValue('VEICULOKM', selectedOrderService.VEICULOKM)
    }
  }, [selectedOrderService]);

  useEffect(() => {
    if (getOrderServiceFormController.serviceOrderTypeResponse?.status === 200) {
      updateOrderServiceTypes();
    }
    if (getOrderServiceFormController.serviceResponse?.status === 200) {
      updateService();
    }
  }, [getOrderServiceFormController.serviceOrderTypeResponse, getOrderServiceFormController.serviceResponse]);

  const serviceOrderTypes = getOrderServiceFormController.serviceOrderTypeData.map((serviceType) => {
    return { label: serviceType.DESCRICAO, value: serviceType.ID }
  });

  const searchServiceOrderTypes = (event: any) => {
    let filteredServiceOrderTypes;
    if (!event.query.trim().length) {
      filteredServiceOrderTypes = [...serviceOrderTypes, ...serviceOrderTypeResponse];
    }
    else {
      filteredServiceOrderTypes = [serviceOrderTypes, ...serviceOrderTypeResponse].filter((serviceOrderType) => {
        return serviceOrderType.label.toLowerCase().includes(event.query.toLowerCase());
      });
    }
    setFilteredServiceOrderType(filteredServiceOrderTypes);
  };

  const extraFormDialogHeader = (
    <div className="p-fluid p-d-flex p-flex-row p-jc-between">
      <div>
        <h5>Cadastrar {getOrderServiceFormController.selectedField}</h5>
      </div>
      <div>
        <Button label="Fechar" icon="pi pi-times" className="p-button-text p-fluid" onClick={handleOrderServiceFormController.closeFormDialog} />
      </div>
    </div>
  );

  const updateOrderServiceTypes = () => {
    handleOrderServiceFormController.closeFormDialog();
    let OrderServiceTypeUpdate = { label: getOrderServiceFormController.serviceOrderTypeResponse?.data.DESCRICAO, value: getOrderServiceFormController.serviceOrderTypeResponse?.data.ID };
    let OrderServiceTypeList = [...serviceOrderTypeResponse, OrderServiceTypeUpdate];
    if (!!OrderServiceTypeUpdate.value) {
      setServiceOrderTypeResponse(OrderServiceTypeList)
      setValueServiceOrderType(OrderServiceTypeList[0].label);
      getOrderServiceFormController.formikServiceType.setFieldValue('TIPOORDEMSERVICO', OrderServiceTypeList[0].value);
    };
  }

  const updateService = () => {
    handleOrderServiceFormController.closeFormDialog();
    let ServiceUpdate = { label: getOrderServiceFormController.serviceResponse?.data.DESCRICAO, value: getOrderServiceFormController.serviceResponse?.data.ID };
    let ServiceList = [...serviceResponse, ServiceUpdate];
    if (!!ServiceUpdate.value) {
      setServiceResponse(ServiceList)
      setValueServiceOrderType(ServiceList[0].label);
      getOrderServiceFormController.formikService.setFieldValue('DESCRICAO', ServiceList[0].value);
    };
  }

  const itemTemplateProduct = (product: filteredFieldProps) => {
    return (
      <div className="list-order-service">
        <div className="item-order-service">
          <h6 className="item p-mb-2">{product.DESCRICAO_PRODUTO}</h6>
        </div>
        <div className="item-order-service">
          <h6 className="item p-mb-2 p-mr-2">R$ {product.VALOR_PRODUTO}</h6>
          <FontAwesomeIcon
            style={{ margin: "0 20" }}
            onClick={() => {
              handleOrderServiceFormController.reduceProduct(product);
            }}
            icon={faMinus}
            size={'1x'}
            cursor='pointer' />
          <h6 className="item p-mb-2" style={{ marginTop: '0px' }}>{product.QUANTIDADE_PRODUTO}</h6>
          <FontAwesomeIcon
            style={{ margin: "0 20" }}
            onClick={() => {
              handleOrderServiceFormController.addProductList(product);
            }}
            icon={faPlus}
            size={'1x'}
            cursor='pointer'
          />
          <FontAwesomeIcon
            style={{ margin: "0 10", color: 'red' }}
            onClick={() => {
              handleOrderServiceFormController.removeProduct(product)
            }}
            icon={faTimes}
            size={'1x'}
            cursor='pointer' />
        </div>
      </div>
    );
  }

  const itemTemplateService = (service: filteredFieldProps) => {
    return (
      <div className="list-order-service">
        <div className="item-order-service">
          <h6 className="item p-mb-2">{service.DESCRICAO_SERVICO}</h6>
        </div>
        <div className="item-order-service">
          <h6 className="item p-mb-2 p-mr-2">R$ {service.VALOR_SERVICO}</h6>
          <FontAwesomeIcon
            style={{ margin: "0 20" }}
            onClick={() => {
              handleOrderServiceFormController.reduceService(service);
            }}
            icon={faMinus}
            size={'1x'}
            cursor='pointer' />
          <h6 className="item p-mb-2 p-mr-2" style={{ marginTop: '0px' }}>{service.QUANTIDADE_SERVICO}</h6>
          <FontAwesomeIcon
            style={{ margin: "0 20" }}
            onClick={() => {
              handleOrderServiceFormController.addServiceList(service);
            }}
            icon={faPlus}
            size={'1x'}
            cursor='pointer'
          />

          <FontAwesomeIcon
            style={{ margin: "0 10", color: 'red' }}
            onClick={() => {
              handleOrderServiceFormController.removeService(service)
            }}
            icon={faTimes}
            size={'1x'}
            cursor='pointer'
          />
        </div>
      </div>
    );
  }

  const searchProduct = (event: any) => {
    const products = getOrderServiceFormController.ProductData.map((product: any) => {
      return { DESCRICAO_PRODUTO: product.DESCRICAO, AX_PRODUTO: product.ID, VALOR_PRODUTOBASE: product.ULTIMOVALORCOMPRA, VALOR_PRODUTO: product.ULTIMOVALORCOMPRA, QUANTIDADE_PRODUTO: 1 }
    });

    if (!event.query.trim().length) {
      setFilteredProduct(products)
    }
    else {
      setFilteredProduct(products.filter((product: any) => {
        return product.DESCRICAO_PRODUTO.toLowerCase().includes(event.query.toLowerCase());
      }));
    }
  }

  const searchService = (event: any) => {
    const services = getOrderServiceFormController.ServiceData.map((service: any) => {
      return { DESCRICAO_SERVICO: service.DESCRICAO, FT_SERVICO: service.ID, VALOR_SERVICOBASE: service.VALOR, VALOR_SERVICO: service.VALOR, QUANTIDADE_SERVICO: 1 }
    });

    if (!event.query.trim().length) {
      setFilteredService(services)
    }
    else {
      setFilteredService(services.filter((service) => {
        if (service.DESCRICAO_SERVICO.toLowerCase().includes(event.query.toLowerCase())) {
          return service;
        }
      }));
    }
  }

  if (getOrderServiceFormController.loading) {
    return <LoadingScreen />
  }

  return (
    <div style={{ height: '100%' }} className="card p-align-center p-justify-center">
      <Toast ref={getOrderServiceFormController.toast} />
      <h5>Nova ordem de serviço</h5>
      <div className="p-grid p-fluid">
        <div className="p-field p-col-12 p-md-8">
          <label htmlFor="descricao">Descrição</label>
          <InputText id="descricao" type="text" disabled={true}
            value={selectedOrderService.DESCRICAO_DEMANDA}
          />
        </div>
        <div className="p-field p-col-12 p-md-4">
          <label htmlFor="veiculo" >Veiculo</label>
          <InputText id="veiculo" type="text" disabled={true}
            value={selectedOrderService.DESCRICAO_VEICULO}
          />
        </div>
        <div className="p-field p-col-12 p-md-3">
          <label htmlFor="placa" >Placa</label>
          <InputText id="placa" type="text" disabled={true}
            value={selectedOrderService.PLACA_VEICULO}
          />
        </div>
        <div className="p-field p-col-12 p-md-3">
          <label htmlFor="anomodelo">Ano/Modelo</label>
          <InputText id="anomodelo" type="text" disabled={true}
            value={selectedOrderService.ANOMODELO}
          />
        </div>
        <div className="p-field p-col-12 p-md-3">
          <label htmlFor="cor" >Cor</label>
          <InputText id="cor" type="text" disabled={true}
            value={selectedOrderService.COR}
          />
        </div>
        <div className="p-field p-col-12 p-md-3">
          <label htmlFor="chassi" >Numero do Chassi</label>
          <InputText id="chassi" type="text" disabled={true}
            value={selectedOrderService.NUMEROCHASSI}
          />
        </div>
        <div className="p-field p-col-12 p-md-3">
          <label htmlFor="motor" >Numero do Motor</label>
          <InputText id="motor" type="text" disabled={true}
            value={
              (selectedOrderService.NUMEROMOTOR !== null) ?
                selectedOrderService.NUMEROMOTOR : 'Sem número'
            }
            onChange={getOrderServiceFormController.formikEdit.handleChange('NUMEROMOTOR')}
          />
        </div>
        <div className="p-field p-col-12 p-md-3">
          <label htmlFor="veiculokm">Quilometragem</label>
          <InputText id="veiculokm" type="text" keyfilter="num"
            {...getOrderServiceFormController.formikEdit.getFieldProps('VEICULOKM')}
            onChange={getOrderServiceFormController.formikEdit.handleChange('VEICULOKM')}
          />
          <div className={classNames("p-invalid popup-fade", {
            'popup-form-active': getOrderServiceFormController.formikEdit.errors.VEICULOKM,
            'popup-form-inactive': !(getOrderServiceFormController.formikEdit.errors.VEICULOKM),
          })}
          >{getOrderServiceFormController.formikEdit.errors.VEICULOKM}</div>
        </div>
        <div className="p-field p-col-12 p-md-3">
          <label htmlFor="tipoServico">Tipo de Manutenção</label>
          <div className="p-inputgroup">
            <AutoComplete id="tipoServico"
              value={valueServiceOrderType}
              field="label" placeholder="Buscar..."
              onChange={(e) => {
                setValueServiceOrderType(e.value)
                getOrderServiceFormController.formikEdit.setFieldValue('TIPOORDEMSERVICO', filteredServiceOrderTypes.find((ServiceOrderType) => {
                  return valueServiceOrderType.toLowerCase() === ServiceOrderType.label.toLowerCase()
                })?.value || '')
              }}
              onSelect={(e) => {
                setValueServiceOrderType(e.value.label)
                getOrderServiceFormController.formikEdit.setFieldValue('TIPOORDEMSERVICO', e.value.value)
              }}
              suggestions={filteredServiceOrderTypes} completeMethod={searchServiceOrderTypes}
              dropdown dropdownMode="current" minLength={2} delay={0}
            />
          </div>
          <div className={classNames("p-invalid popup-fade", {
            'popup-form-active': getOrderServiceFormController.formikEdit.touched.TIPOORDEMSERVICO && getOrderServiceFormController.formikEdit.errors.TIPOORDEMSERVICO,
            'popup-form-inactive': !(getOrderServiceFormController.formikEdit.touched.TIPOORDEMSERVICO && getOrderServiceFormController.formikEdit.errors.TIPOORDEMSERVICO),
          })}>{getOrderServiceFormController.formikEdit.errors.TIPOORDEMSERVICO}</div>
        </div>

        <div className="p-field p-col-12 p-md-3">
          <label htmlFor="dataefetivada">Data do movimento</label>
          <InputMask id="dataefetivada"
            mask="99/99/9999" placeholder="__/__/____"
            {...getOrderServiceFormController.formikEdit.getFieldProps('DATAEFETIVADA')}
            onChange={(e) => getOrderServiceFormController.formikEdit.setFieldValue('DATAEFETIVADA', e.value)}
          />
          <div className={classNames("p-invalid popup-fade", {
            'popup-form-active': getOrderServiceFormController.formikEdit.touched.DATAEFETIVADA && getOrderServiceFormController.formikEdit.errors.DATAEFETIVADA,
            'popup-form-inactive': !(getOrderServiceFormController.formikEdit.touched.DATAEFETIVADA && getOrderServiceFormController.formikEdit.errors.DATAEFETIVADA),
          })}
          >
            {getOrderServiceFormController.formikEdit.errors.DATAEFETIVADA}
          </div>
        </div>

        <div className="p-field p-col-12 p-md-6">
          <label htmlFor="product">Produtos e peças</label>
          <AutoComplete id="product"
            value={valueProduct.DESCRICAO_PRODUTO}
            field="DESCRICAO_PRODUTO"
            onChange={(e) => {
              setValueProduct(e.value)
            }}
            onSelect={(e) => {
              setValueProduct(e.value);
              handleOrderServiceFormController.addProductList(e.value)
            }}
            suggestions={filteredProduct} completeMethod={searchProduct}
            dropdown placeholder="Buscar..."
          />
        </div>
        <div className="p-field p-col-12 p-md-6">
          <label htmlFor="service">Serviços</label>
          <div className="p-inputgroup">
            <Button type="button" icon="pi pi-plus" className="p-button-primary " onClick={() => handleOrderServiceFormController.openFormDialog('Serviço')} />
            <AutoComplete id="service"
              value={valueService.DESCRICAO_SERVICO}
              field="DESCRICAO_SERVICO"
              onChange={(e) => {
                setValueService(e.value)
              }}
              onSelect={(e) => {
                setValueService(e.value)
                handleOrderServiceFormController.addServiceList(e.value)
              }}
              suggestions={filteredService} completeMethod={searchService}
              dropdown placeholder="Buscar..."
            />
          </div>
        </div>
        <div className="p-field p-col-12 p-md-6">
          <OrderList
            value={
              getOrderServiceFormController.productList
            }
            className="p-orderlist-personal"
            itemTemplate={itemTemplateProduct}
            header="Produtos" listStyle={{ overflowY: 'scroll', maxHeight: 168 }}
          />
        </div>
        <div className="p-field p-col-12 p-md-6">
          <OrderList
            value={
              getOrderServiceFormController.serviceList
            }
            className="p-orderlist-personal"
            itemTemplate={itemTemplateService}
            header="Serviços" listStyle={{ overflowY: 'scroll', maxHeight: 168 }}
          />
        </div>
      </div>

      <div className="p-fluid p-grid p-justify-between">
        <div className="p-col-12 p-md-3">
          <Button
            type="button"
            label={"Guardar alterações"}
            onClick={() => getOrderServiceFormController.formikEdit.handleSubmit()}
          />
        </div>

        <div className="p-col-12 p-md-3">
          <Button
            style={{ backgroundColor: 'red', borderColor: 'red' }}
            type="button"
            label="Finalizar"
            onClick={() => {
              getOrderServiceFormController.formikEdit.handleSubmit();
            }}
          />
        </div>

        <div className="p-col-12 p-md-4">
          <Button
            type="button"
            className="p-button-secondary"
            label="Voltar para listagem"
            onClick={() => history.goBack()}
          />
        </div>
      </div>

      <Dialog style={{ width: '450px' }} contentStyle={{ height: '100%' }}
        visible={getOrderServiceFormController.formDialog}
        onHide={updateOrderServiceTypes}
        header={extraFormDialogHeader} closable={false}
        modal
      >
        <div className="confirmation-content p-fluid">
          <div className="p-field">
            <label htmlFor="name">Nome</label>
            <InputText id="name" type="text"
              value={getOrderServiceFormController.formikServiceType.values.DESCRICAO}
              onChange={getOrderServiceFormController.formikServiceType.handleChange('DESCRICAO')}
            />
            <div className={classNames("p-invalid popup-fade", {
              'popup-form-active': getOrderServiceFormController.formikServiceType.touched.DESCRICAO && getOrderServiceFormController.formikServiceType.errors.DESCRICAO,
              'popup-form-inactive': !(getOrderServiceFormController.formikServiceType.touched.DESCRICAO && getOrderServiceFormController.formikServiceType.errors.DESCRICAO),
            })}
            >{getOrderServiceFormController.formikServiceType.errors.DESCRICAO}</div>
          </div>
          <Button
            type="submit"
            label="Cadastrar"
            onClick={() => getOrderServiceFormController.formikServiceType.handleSubmit()}
          />
        </div>
        {getOrderServiceFormController.loading ? <LoadingScreen color="#0388e5" /> : <></>}
      </Dialog>

      <Dialog style={{ width: '450px' }} contentStyle={{ height: '100%' }}
        visible={getOrderServiceFormController.formDialog && getOrderServiceFormController.selectedField === 'Serviço'}
        onHide={updateService}
        header={extraFormDialogHeader} closable={false}
        modal
      >
        <div className="confirmation-content p-fluid">
          <div className="p-field">
            <label htmlFor="name">Descrição</label>
            <InputText id="name" type="text"
              value={getOrderServiceFormController.formikService.values.DESCRICAO}
              onChange={getOrderServiceFormController.formikService.handleChange('DESCRICAO')}
            />
            <div className={classNames("p-invalid popup-fade", {
              'popup-form-active': getOrderServiceFormController.formikService.touched.DESCRICAO && getOrderServiceFormController.formikService.errors.DESCRICAO,
              'popup-form-inactive': !(getOrderServiceFormController.formikService.touched.DESCRICAO && getOrderServiceFormController.formikService.errors.DESCRICAO),
            })}
            >{getOrderServiceFormController.formikService.errors.DESCRICAO}</div>
          </div>
          <Button
            type="submit"
            label="Cadastrar"
            onClick={() => getOrderServiceFormController.formikService.handleSubmit()}
          />
        </div>
        {getOrderServiceFormController.loadingServices ? <LoadingScreen color="#0388e5" /> : <></>}
      </Dialog>
    </div>
  );
}

export default EditOrderServiceForm;
